import { render, staticRenderFns } from "./prompt-media-file-selection.vue?vue&type=template&id=21b2422c"
import script from "./prompt-media-file-selection.vue?vue&type=script&lang=js"
export * from "./prompt-media-file-selection.vue?vue&type=script&lang=js"
import style0 from "./prompt-media-file-selection.vue?vue&type=style&index=0&id=21b2422c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports